import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";

import { useTranslation } from "react-i18next";
import ContentBox from "../../base/tamplate/ContentBox";
import { ContentContainerProps } from "../../../interfaceTypes/ContentsProps";

import { ReactComponent as TableEditImg } from '../../../img/ico-table-edit.svg';
import { ReactComponent as InfoImg } from '../../../img/ico-msg-info-2.svg';
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";
import { actionMenus } from "./VmSubnetData";
import ListTable from "../../base/table/listTable";
import { VmNetworkDetailData } from "./VmNetworkData";


interface VmNetworkDetailProps extends ContentContainerProps {
    detailData:VmNetworkDetailData;
    updateFunction: Function;

    clickActionMenu: Function;
    selectRow: Function;
    fetchData: any;
    clickRow: Function;
    pageCount: number;
    headers: any;
    tableData: any;
    totalItemCount: number;
    refreshYn: boolean;
    loadMainDataYn: boolean;

}

export default function VmNetworkDetail(props:VmNetworkDetailProps) {
    const { t } = useTranslation();

    return (
        <ContentBox title={t("VM_NETWORK_MGMT_DETAIL_TITLE")} subtitle={t("VM_NETWORK_MGMT_DETAIL_SUBTITLE")} infoText={props.infoText} infoError={props.infoError} back={true} >
            <View style={style.topContainer}>
                <View style={{
                    flexDirection: "row", alignItems: "center", justifyContent: "flex-end"
                }}>
                    <View style={{ flexDirection: "row", alignItems: "center" }}>
                        <Text style={style.dateTitle}>
                            {t("LAST_UPDATE_DATE_TEXT")}
                        </Text>
                        <Text style={style.dateData}>
                            {props.detailData && props.detailData.update_ts ? props.detailData.update_ts : ""}
                        </Text>
                    </View>
                    <View style={{ flexDirection: "row", alignItems: "center", marginLeft: 30 }}>
                        <Text style={style.dateTitle}>
                            {t("CREATE_DATE_TEXT")}
                        </Text>
                        <Text style={style.dateData}>
                            {props.detailData && props.detailData.create_ts ? props.detailData.create_ts : ""}
                        </Text>
                    </View>
                </View>

                <View>
                    <View style={{...style.boxContainer, height: 380}}>
                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 50}}>
                            <Text style={style.boxContentTitle}>
                                {t("BASE_INFO_TEXT")}
                            </Text>
                            <div 
                                style={{display: "flex", alignItems: "center", marginLeft: "auto", cursor: "pointer"}}
                                onClick={() => {
                                    props.updateFunction();
                                }}
                            >
                                <TableEditImg/>
                                <Text style={{
                                    marginLeft: 2,
                                    fontFamily: FONT.MEDIUM,
                                    fontSize: 12,
                                    color: "#3c5df2"
                                }}>
                                    {t("INFO_EDIT_TEXT")}
                                </Text>
                            </div>
                        </View>
                        <View style={{flexDirection: "row"}}>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("NETWORK_NAME_TEXT")}
                                    </Text>
                                    <Text style={{...style.boxContentDataText,fontFamily: FONT.MEDIUM, fontSize: 14, marginRight: 20, color: "#0853fb"}}>
                                        {props.detailData.network_name}
                                    </Text>
                                </View>

                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("SHARE_TYPE_TEXT")}
                                    </Text>
                                    <View style={{
                                        alignItems: "center", justifyContent: "center",
                                        width: 56, height: 20,
                                        paddingLeft: 10, paddingRight: 10,
                                        borderRadius: 10,
                                        backgroundColor: props.detailData.share_type_code === "PUB" ? "#66abe8" : props.detailData.share_type_code === "PRJ" ? "#92ca6e" : "#b6bfce",
                                    }}>
                                        <Text style={{
                                            fontFamily: FONT.REGULAR,
                                            fontSize: 12,
                                            color: "#fff"
                                        }}>
                                            {
                                                props.detailData.share_type_code === "PUB" ? "Public"
                                                : props.detailData.share_type_code === "PRJ" ? "Personal"
                                                : props.detailData.share_type_code === "HDN" ? "Hidden"
                                                : "None"
                                            }
                                        </Text>
                                    </View>
                                </View>

                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("TARGET_PROJECT")}
                                    </Text>
                                    <Text style={style.boxContentDataText}>
                                        {props.detailData.project && props.detailData.project.project_name}
                                    </Text>
                                </View>

                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("NETWORK_TYPE_TEXT")}
                                    </Text>
                                    <Text style={{...style.boxContentDataText, color: "#3a8344"}}>
                                        {props.detailData.network_type_code}
                                    </Text>
                                </View>
                            </View>
                            <View>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("STATUS_TEXT")}
                                    </Text>
                                    <View style={{ flexDirection: "row", alignItems: "center"}}>
                                        <Text style={{
                                            fontFamily: FONT.REGULAR,
                                            fontSize: 12,
                                            color: props.detailData.network_status_code === "ACT" ? "#3a8344" : props.detailData.network_status_code === "ERR" ? "#e6735c": "#8c8c8c",
                                        }}>
                                            {
                                                props.detailData.network_status_code === "ACT" ? "Active"
                                                : props.detailData.network_status_code === "DWN" ? "Down"
                                                : props.detailData.network_status_code === "BLD" ? "Build"
                                                : "Error"
                                            }
                                        </Text>
                                    </View>
                                </View>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("NETWORK_ACTIVE_STATE_TEXT")}
                                    </Text>
                                    <View style={{ flexDirection: "row", alignItems: "center",}}>
                                        {
                                            props.detailData.up_yn ? <StatusStableImg/> : <StatusBlockImg/>
                                        }
                                        <Text style={{
                                            fontFamily: FONT.REGULAR,
                                            fontSize: 12,
                                            color: props.detailData.up_yn ? "#3a8344" : "#8c8c8c",
                                        }}>
                                            {props.detailData.up_yn ? "Up" : "Down"}
                                        </Text>
                                    </View>
                                </View>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("EXTERNAL_NETWORK_CONNECT_TEXT")}
                                    </Text>
                                    <Text style={{...style.boxContentDataText, color: "#0853fb"}}>
                                        {props.detailData.external_yn ? <StatusStableImg /> : <StatusBlockImg />}
                                    </Text>
                                </View>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("VM_NETWORK_VLAN_ID_TEXT")}
                                    </Text>
                                    <Text style={{...style.boxContentDataText}}>
                                        {props.detailData.vlan_id}
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View style={{
                            flexDirection: "row", alignItems: "center",
                            width: "100%", height: 40,
                            borderRadius: 2,
                            backgroundColor: "#fafafa",
                            paddingLeft: 10
                        }}>
                            <InfoImg/>
                            <Text style={{
                                marginLeft: 10,
                                fontFamily: FONT.REGULAR,
                                fontSize: 12,
                                lineHeight: 18,
                                color: "#9ea0a5"
                            }}>
                                {t("VM_NETWORK_DETAIL_INFO_MESSAGE")}
                            </Text>
                        </View>
                    </View>
                    <View style={{...style.boxContainer, height: 720}}>
                        <View style={{flexDirection: "row", alignItems: "center"}}>
                            <Text style={{...style.boxContentTitle, fontFamily: FONT.REGULAR, color: "#3a3b3f"}}>
                                {t("SUBNET_LIST_TEXT")}
                            </Text>
                        </View>{
                            props.loadMainDataYn == true?
                            <View style={{marginTop: 24}}>
                                <ListTable
                                    id={"subnet"}
                                    actionMenus={actionMenus}
                                    actionMenuClickCb={props.clickActionMenu}
                                    searchBarYn={true}
                                    searchBarPlaceholder={t("SUBNET_SEARCH_BAR_PLACEHOLDER_TEXT")}
                                    pageYn={true}
                                    rowCheckYn={true}
                                    rowCheckCb={props.selectRow}
                                    fetchDataCb={props.fetchData}
                                    pageCount={props.pageCount}
                                    rowClickCb={props.clickRow}
                                    pageSize={20}
                                    tableHeaders={props.headers}
                                    tableData={props.tableData}
                                    totalItemCount={props.totalItemCount}
                                    detailYn={true}
                                    refreshYn={props.refreshYn}
                                    canLoadYn={props.loadMainDataYn}
                                />
                            </View>:null
                            }
                    </View>
                </View>
            </View>
        </ContentBox>
    );
}

const style = StyleSheet.create({
    topContainer: {
        width: 1090,
        minHeight: 860,
    },
    boxContainer: {
        marginTop: 20,
        paddingTop: 34, paddingLeft: 50, paddingRight: 40, paddingBottom: 45,
        borderRadius: 8,
        boxShadow: "0 10px 12px 0 rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(0, 0, 0, 0.05)",
        borderStyle: "solid", borderWidth: 1, borderColor: "#e5e9ec",
        backgroundColor: "#fff"
    },
    dateTitle: {
        marginRight: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#8793a3"
    },
    dateData: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    },
    boxContentTitle: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333"
    },
    boxContentHeaderText: {
        width: 130,
        marginRight: 52,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 12,
        color: "#333"
    },
    boxContentDataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    settingImg: {
        marginLeft: "auto",
        cursor: "pointer"
    },
    resourceBox: {
        flexDirection: "row",
        width: 760, minHeight: 70,
        borderRadius: 10,
        backgroundColor: "#f5f7fa",
        padding: 20,
    },
    imgBox: {
        alignItems: "center", justifyContent: "center",
        width: 36, height: 36,
        marginRight: 16,
        borderRadius: 10,
        backgroundColor: "rgba(182, 191, 206, 0.3)",
    },
    resourceFixedText: {
        width: 75,
        marginRight: 90,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 12,
        color: "#333"
    },
    resourceDataText: {
        fontFamily: FONT.BOLD,
        fontSize: 14,
        lineHeight: 14,
        color: "#333"
    },
    resourceSubText: {
        marginLeft: 6,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
});